import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { useLang } from "@/context/LanguageContext";

export default function CookieBanner() {
  const { t } = useLang();
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem("he_cookie_consent")) setShow(true);
  }, []);

  const decide = (val) => {
    localStorage.setItem("he_cookie_consent", val);
    setShow(false);
  };

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ y: 120, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 120, opacity: 0 }}
          transition={{ type: "spring", stiffness: 260, damping: 26 }}
          className="fixed bottom-0 inset-x-0 z-[70] p-3 sm:p-4"
          data-testid="cookie-banner"
        >
          <div className="mx-auto max-w-3xl bg-paper border border-line shadow-xl rounded-2xl p-4 sm:p-5 flex flex-col sm:flex-row items-start sm:items-center gap-4">
            <p className="text-xs sm:text-sm text-stone leading-relaxed flex-1">{t.cookie.text}</p>
            <div className="flex gap-2 shrink-0 w-full sm:w-auto">
              <button
                data-testid="cookie-reject"
                onClick={() => decide("essential")}
                className="flex-1 sm:flex-none h-10 px-4 rounded-xl border border-line text-sm font-medium hover:bg-mist transition-colors"
              >
                {t.cookie.reject}
              </button>
              <button
                data-testid="cookie-accept"
                onClick={() => decide("all")}
                className="flex-1 sm:flex-none h-10 px-5 rounded-xl bg-brand text-white text-sm font-semibold hover:bg-brandhover transition-colors"
              >
                {t.cookie.accept}
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
